import React from "react";
import SignaturePad from "react-signature-canvas";

// Resize the bitmap and stroke coordinates together so existing ink and new input align.
export default class ResponsiveSignature extends React.Component {
  componentDidMount() {
    const canvas = this.pad.getCanvas();
    this.width = canvas.offsetWidth;
    this.height = canvas.offsetHeight;
    this.observer = new ResizeObserver(this.resize);
    this.observer.observe(canvas);
    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount() {
    this.observer.disconnect();
    window.removeEventListener("resize", this.resize);
  }

  resize = () => {
    const canvas = this.pad.getCanvas();
    const width = canvas.offsetWidth;
    const height = canvas.offsetHeight;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    if (!width || !height || (canvas.width === Math.round(width * ratio) &&
      canvas.height === Math.round(height * ratio))) return;
    const strokes = this.pad.toData().map(group => group.map(point => ({ ...point,
        x: point.x * width / this.width,
        y: point.y * height / this.height
      })));
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    canvas.getContext("2d").scale(ratio, ratio);
    this.pad.clear();
    this.pad.fromData(strokes);
    this.width = width;
    this.height = height;
  };

  setPad = pad => {
    this.pad = pad;
    if (this.props.signatureRef) this.props.signatureRef(pad);
  };

  render() {
    return <SignaturePad ref={this.setPad} clearOnResize={false}
      onEnd={this.props.onEnd} canvasProps={this.props.canvasProps} />;
  }
}
